import React, { useState } from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import NativeSelect from '@material-ui/core/NativeSelect';
import MaskedInput from 'react-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import prefixes from '@dev-togetherprice/constants.prefixes';
const useStyles = makeStyles((theme) => createStyles({
    root: {
        borderWidth: 1,
        borderColor: theme.palette.grey.A700,
        borderRadius: 3,
        borderStyle: 'solid',
        overflow: 'hidden',
    },
    selectWrapper: {
        width: 65,
        height: 55,
        backgroundColor: theme.palette.grey.A100,
        borderRight: `1px solid ${theme.palette.grey[300]}`,
        fontSize: 15,
        fontFamily: 'Poppins',
        position: 'relative',
    },
    selectControl: {
        opacity: 0,
        height: '100%',
        '& select': {
            height: '100%',
        },
    },
    preview: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
    },
    inputFormControl: {
        width: '100%',
        height: '100%',
        paddingLeft: theme.spacing(1),
    },
    input: {
        width: '100%',
        height: '100%',
        outline: 'none',
        border: 'none',
        fontSize: 16,
    },
}));
const PhoneNumberInput = ({ onChange }) => {
    const [selectedAreaCode, updateAreaCode] = useState('+39');
    const [phoneArea, updatePhoneArea] = useState('');
    const classes = useStyles();
    const handleUpdate = (area, phone) => {
        onChange(`${area}${phone}`);
    };
    const handleChange = (event) => {
        updateAreaCode(event.target.value);
        handleUpdate(event.target.value, phoneArea);
    };
    const handleNumberChange = (event) => {
        updatePhoneArea(event.target.value);
        handleUpdate(selectedAreaCode, event.target.value);
    };
    return (React.createElement(Grid, { container: true, className: classes.root },
        React.createElement(Grid, { item: true, className: classes.selectWrapper },
            React.createElement("div", { className: classes.preview }, selectedAreaCode),
            React.createElement(NativeSelect, { value: selectedAreaCode, onChange: handleChange, className: classes.selectControl, inputProps: {
                    name: 'area',
                    id: 'phone-area',
                } }, 
            // eslint-disable-next-line max-len
            prefixes.length > 0 &&
                prefixes.map((prefix) => (React.createElement("option", { value: prefix.value, key: prefix.label, className: 'menu-item' }, prefix.label))))),
        React.createElement(Grid, { item: true, xs: true },
            React.createElement(FormControl, { className: classes.inputFormControl },
                React.createElement(MaskedInput, { value: phoneArea, onChange: handleNumberChange, className: classes.input, mask: createNumberMask({
                        prefix: '',
                        suffix: '',
                        allowDecimal: false,
                        integerLimit: 12,
                        allowNegative: false,
                        allowLeadingZeroes: false,
                        includeThousandsSeparator: false,
                    }), inputMode: 'numeric', guide: false })))));
};
export default PhoneNumberInput;
